import { useFormikContext } from 'formik';
import React from 'react';

import { useTouchErrorsOnLoad } from 'hooks';

type Props = {
  loadedValues: unknown;
};

// For forms rendered via <Formik>{(formik) => ...}</Formik>, where the hook can't be called directly.
export const TouchErrorsOnLoad: React.FC<Props> = ({ loadedValues }) => {
  useTouchErrorsOnLoad(useFormikContext(), loadedValues);
  return null;
};
